/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import type { ComponentChildren, ComponentProps, Ref } from 'preact';

import { CollectionInteractionContext } from '#hooks/UNSAFE_useCollectionInteractionContext';
import { classNames } from '#utils/UNSAFE_classNames';
import { preventDefaultForCurrentTarget } from './eventUtils';
import { dropdownStyles } from './themes/dropdownStyles.css';

type Props = Pick<ComponentProps<'div'>, 'id' | 'onKeyDown'> & {
  children?: ComponentChildren;
  dropdownListRef?: Ref<HTMLDivElement>;
  hasTopGap?: boolean;
  hasBottomGap?: boolean;
  isLoading?: boolean;
};

export function DropdownList({
  children,
  id,
  dropdownListRef,
  hasTopGap = true,
  hasBottomGap = true,
  isLoading = false,
  onKeyDown
}: Props) {
  const styleClasses = classNames([
    dropdownStyles.list.base,
    hasTopGap && dropdownStyles.list.topGap,
    hasBottomGap && dropdownStyles.list.bottomGap,
    isLoading && dropdownStyles.list.loading
  ]);
  return (
    <CollectionInteractionContext.Provider value={'embedded'}>
      <div
        ref={dropdownListRef}
        class={styleClasses}
        id={id}
        onMouseDown={preventDefaultForCurrentTarget}
        onKeyDown={onKeyDown}>
        {children}
      </div>
    </CollectionInteractionContext.Provider>
  );
}
